<span style="position:relative; top:-8px">
  <i
    class="far fa-info-circle info-tooltip-icon"
    matTooltip="{{text}}"
    matTooltipPosition="after"
    [attr.aria-label]="'IMAGE_DESCRIPTION.INFO' | translate"
  ></i>
</span>